const version_json = require('../version.json')

export default {
  loading: false,
  errors: [],
  token: localStorage.getItem('token'),
  profile: null,
  license: null,
  products: {},
  request2buy: Boolean(localStorage.getItem('request_has_been_sent')),
  version: version_json.version
}